import { useEffect, useState } from 'react';
import * as React from 'react';
import Modal from '@sdk/components/ui/modal/Modal';
import { ModalState } from '@sdk/components/ui/modal/useModalState';
import { ModalPosition } from '@sdk/components/ui/modal/modal.types';

import { IS_SAFARI } from '@web/common/utils/currentBrowser';
import EditLinkForm from '@web/richText/components/linkModal/EditLinkForm';
import ViewLink from '@web/richText/components/linkModal/ViewLink';
import { BodyContainer } from '@web/richText/components/linkModal/linkModal.styles';

type Props = {
  modalState: ModalState;
  onSubmit: () => void;
  modalPosition?: ModalPosition;
  onDismiss?: (event?: Event) => void;
  initialUrl: string;
  isOpenedFromToolbar: boolean;
};

const LinkModal: React.FC<React.PropsWithChildren<Props>> = ({
  modalState,
  onSubmit,
  modalPosition,
  onDismiss,
  initialUrl,
  isOpenedFromToolbar,
}) => {
  const { isVisible, close, config } = modalState;
  const [isEditMode, setIsEditMode] = useState(!initialUrl);
  const [url, setUrl] = useState('');

  useEffect(() => {
    setIsEditMode(!initialUrl);
    setUrl(initialUrl);
  }, [initialUrl]);

  const onModalDismiss = (event?: Event): void => {
    if (!IS_SAFARI || isOpenedFromToolbar) {
      onDismiss?.(event);
    }

    close();
  };

  return (
    <Modal
      config={config}
      isVisible={isVisible}
      onDismiss={onModalDismiss}
      modalPosition={modalPosition}
      fullScreen={false}>
      <BodyContainer
        onMouseDown={(event): void => {
          event.nativeEvent.stopImmediatePropagation();
        }}>
        {isEditMode && (
          <EditLinkForm
            initialUrl={url}
            isVisible={isVisible}
            close={(): void => close()}
            dismiss={onModalDismiss}
            onSubmit={onSubmit}
          />
        )}

        {!isEditMode && (
          <ViewLink url={url} editLink={(): void => setIsEditMode(true)} close={onModalDismiss} />
        )}
      </BodyContainer>
    </Modal>
  );
};

export default LinkModal;
